const mobileSection = $('#mobile-section');
const mobileCards = mobileSection.find('.mobile-card-parent');
const mobileVideoParent = mobileSection.find('.mobile-video-parent');
const mobileVideosOverflows = mobileSection.find('.mobile-video-overflow');
const mobileVideos = mobileSection.find('.mobile-video-player');
const mobileButton = mobileSection.find('.button-parent')
const iosAppLink = mobileSection.attr('data-ios-app-link');
const androidAppLink = mobileSection.attr('data-android-app-link');

let prevVideoID = undefined;

const getDeviceStoreLink = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera || '';
    const isAndroid = /Android/i.test(userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent)
        || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if (isAndroid && androidAppLink) {
        return androidAppLink;
    }

    if (isIOS && iosAppLink) {
        return iosAppLink;
    }

    return iosAppLink || androidAppLink || mobileButton.attr('href');
}

const initMobileButtonRedirect = () => {
    if (!mobileButton.length) {
        return;
    }

    mobileButton.off('click.dashboardMobileRedirect').on('click.dashboardMobileRedirect', (event) => {
        const targetLink = getDeviceStoreLink();

        if (!targetLink) {
            return;
        }

        event.preventDefault();
        window.location.href = targetLink;
    });
}

const videoSwitchAnimation = (index) => {
    const videoSwitchTL = gsap.timeline({paused: true});
    const prevVideo = mobileVideosOverflows.eq(index - 1);
    const nextVideo = mobileVideosOverflows.eq(index);

    videoSwitchTL.add(gsap.fromTo(prevVideo, {
        yPercent: 0,
        opacity: 1,
    }, {
        yPercent: -20,
        opacity: 0,
        force3D: true,
    }), 0)

    videoSwitchTL.add(gsap.fromTo(nextVideo, {
        yPercent: 20,
        opacity: 0,
    }, {
        yPercent: 0,
        opacity: 1,
        force3D: true,
    }), 0)

    return videoSwitchTL;
}

const cardsAnimation = (cardLine, cardContent) => {
    const cardInTL = gsap.timeline({paused: true});

    cardInTL.add(gsap.to(cardLine, {
        scaleX: 1,
    }), 0);
    cardInTL.add(gsap.to(cardContent, {
        opacity: 1,
        y: 0,
    }), 0)

    return cardInTL
}

const initCard = (cardLine, cardContent) => {
    gsap.set(cardLine, {scaleX: 0, transformOrigin: '0% 50%'});
    gsap.set(cardContent, {opacity: 0, y: '2vw'});
}

const initMobileCards = () => {
    mobileCards.each(function(index){
        const cardLine = $(this).find('.descriptor-title-line');
        const cardContent = $(this).find('.descriptor-title, .descriptor-bottom');

        if(index === 0){
            gsap.set(cardLine, {scaleX: 1, transformOrigin: '0% 50%'});
            gsap.set(cardContent, {opacity: 1, y: 0});
            return;
        }

        initCard(cardLine, cardContent);
        const cardInTL = cardsAnimation(cardLine, cardContent);
        ScrollTrigger.create({
            trigger: $(this),
            start: `center bottom`,
            end: index === mobileCards.length - 1 ? `bottom+=70% bottom` : `bottom+=150% bottom`,
            onUpdate: (self) => {
                cardInTL.progress(self.progress);
            },
        })

        const videoInTL = videoSwitchAnimation(index)
        ScrollTrigger.create({
            trigger: $(this),
            start: `bottom bottom`,
            end: `bottom+=50% bottom`,
            onUpdate: (self) => {
                videoInTL.progress(self.progress);
            },
        })
    })

}

const addMobileSectionAnimation = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };

  const mobileTL = gsap.timeline({ paused: true });

  mobileTL.add(
    animateSectionTopperIn({
      sectionParent: mobileSection,
      gradientConfig: gradientConfig,
    }).play(),
    0
  );
  
  mobileTL.add(elementInAnimationYWOpacity(mobileVideoParent, '17.1%', 0, 1, 1, 1, 0, 0, 'start', 'pageInEasing', 'pageInEasing').play(), 0);
  mobileTL.add(elementInAnimationYWOpacity(mobileButton, '10%', 0, 1, 0.7, 0.7, 0, 0, 'start', 'pageInEasing', 'pageInEasing').play(), 0.25);

  return mobileTL;
    
}

const initMobileVideos = () => {
    mobileVideosOverflows.each(function(index) {
        gsap.set($(this), {
            zIndex: 1000 - index,
            opacity: index === 0 ? 1 : 0,
            yPercent: index === 0 ? 0 : 20,
            force3D: true,
        });
    });

    mobileVideos.each(function() {
        this.load();
        this.play().catch(() => this.pause());
    });
}

const initMobileSection = () => {
    initMobileVideos();
    initMobileCards();
    initMobileButtonRedirect();

    if(isDesktop()){
        const mobileTL = addMobileSectionAnimation();

        ScrollTrigger.create({
            trigger: mobileSection,
            start: `top top+=90%`,
            once: true,
            onEnter: () => {
                mobileTL.play();
            },
        });
    }
}

addSectionObserver(mobileSection, initMobileSection);
